module.exports = "/_next/static/images/slide-2-8c55679cb11d88551cfe2ed06166da08.jpeg";